import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {StorageUtils} from '../../../utils/storage-utils';
import {ActivityLog} from '../activity-log/activity-log';
import {ActivityLogService} from '../activity-log/activity-log-service';


@Component({
    selector: 'app-list-activity-logs-page',
    templateUrl: './list-activity-logs-page.component.html',
    styleUrls: ['./list-activity-logs-page.component.scss'],
    providers: [
        StorageUtils
    ],
    encapsulation: ViewEncapsulation.None
})
export class ListActivityLogsPageComponent implements OnInit {

    logs: ActivityLog[]

    constructor(
        private activityLogService: ActivityLogService
    ) {
        this.logs = []
    }

    ngOnInit() {
        this.loadData()
    }

    loadData() {
        this.activityLogService.listLastLogs((result, logs) => {
            this.logs = logs
        })
    }
}
